<div class="newAlertNotification mr-4 mt-2 row">
  <div class="col-11"><span>{{ (alertNotification.message | translate) +  alertNotification.alertId }} </span></div>
  <div class="col-1"><button type="button" title="{{ 'notification.close_notification' | translate }}" id="alertNotification.id" class="btn-close ml-2" (click)="closeAlertNotification(alertNotification.id)">&times;</button></div>
</div>

<iframe src="../../../../../assets/media/silence.mp3" type="audio/mpeg" allow="autoplay" id= "audio" hidden></iframe>

<audio autoplay>
    <source src="../../../../../assets/media/alert.mp3" type="audio/mpeg">
        {{ 'general.audio_not_available' | translate }}
</audio>
